import type { CellContext } from '@tanstack/react-table'
import { DownloadIcon, Trash2Icon } from 'lucide-react'

import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  Link,
  RowActionsMenu,
} from '@/components/ui'
import {
  DeleteStatementsDialog,
  ProcessButton,
  type Statement,
} from '@/modules/projects'
import {
  hasStatementFailed,
  isStatementProcessing,
} from '@/modules/projects/status'
import { useDialogActions } from '@/stores/dialog'

export const RowActionsCell = (cell: CellContext<Statement, unknown>) => {
  const { openDialog } = useDialogActions()
  const statement = cell.row.original
  const isProcessing = isStatementProcessing(statement)

  return (
    <RowActionsMenu label="Statement actions">
      <DropdownMenuItem asChild>
        <ProcessButton
          theme="ghost"
          table={cell.table}
          statementsToProcess={[statement]}
          validationBehaviour="disable-only"
        >
          {hasStatementFailed(statement) ? 'Retry' : 'Process'} statement
        </ProcessButton>
      </DropdownMenuItem>
      {statement.fileUrl && (
        <DropdownMenuItem asChild>
          <Link href={statement.fileUrl} newTab className="cursor-pointer">
            <DownloadIcon className="h-4 w-4" />
            Download
          </Link>
        </DropdownMenuItem>
      )}
      <DropdownMenuSeparator />
      <DropdownMenuItem
        onClick={() => openDialog(DeleteStatementsDialog.id, [statement])}
        destructive
        disabled={isProcessing}
      >
        <Trash2Icon className="h-4 w-4" />
        Delete statement
      </DropdownMenuItem>
    </RowActionsMenu>
  )
}
